<nav id="main-nav" [class.scrolled]="isScrolled">
   <div class="nav-container">

      <!-- LOGO -->
      <a class="nav-logo" href="https://nexgencoaches.com/" aria-label="NexGen Home">
         <img src="assets/NEXGEN Logo final.png" alt="NexGen Logo" class="nav-logo-img" />
      </a>

      <!-- DESKTOP LINKS -->
      <div class="nav-links" [class.open]="mobileOpen">
         <a href="https://nexgencoaches.com/" [class.active]="isActive('/')" (click)="closeMobile()">Home</a>

         <a href="https://nexgencoaches.com/programs/" [class.active]="isActive('/programs')"
            (click)="closeMobile()">Programs</a>

         <a href="https://nexgencoaches.com/about-us/" [class.active]="isActive('/about')" (click)="closeMobile()">About
            Us</a>

         <a [routerLink]="['/community']" routerLinkActive="active" (click)="closeMobile()">Community</a>

         <a href="https://nexgencoaches.com/26-founders/" [class.active]="isActive('/founders')"
            (click)="closeMobile()">Founders 26</a>

         <a href="https://nexgencoaches.com/contact-us/" [class.active]="isActive('/contact')"
            (click)="closeMobile()">Contact Us</a>


         <!-- SIGN IN CTA -->
         <a routerLink="/login" class="nav-signin-btn" (click)="closeMobile()">SIGN IN</a>
      </div>

      <!-- MOBILE HAMBURGER -->
      <button class="hamburger" (click)="toggleMobile()" [class.open]="mobileOpen" aria-label="Toggle menu">
         <span></span>
         <span></span>
         <span></span>
      </button>

   </div>
</nav>

<!-- Spacer so content doesn't hide under fixed nav -->
<div class="nav-spacer" [class.scrolled]="isScrolled"></div>